import React, { Component, ReactNode, ReactText } from "react";
import { connect, useSelector } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import filter from "lodash/filter";

import "./SearchDocumentProductCatalog.less";

import { ColumnType, TableRowSelection } from "antd/lib/table/interface";
import Button from "antd/lib/button";
import Select from "antd/lib/select";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import Input from "antd/lib/input";

import ConfigProvider from "antd/lib/config-provider";

import NoProductFoundIcon from "@/Assets/ProductsPage/NoProductFoundIcon.svg";
import SearchSomethingProductsIcon from "@/Assets/ProductsPage/StartSearching.svg";
import ZomentumLogo from "config/assets/Logos/ZomentumLogo.gif";

import {
	DefaultTableFilterSortSearchParameters,
	DefaultTableFilterSortSearch,
	DefaultErrorMessage,
	EtilizeLocale,
	CustomDistributorIntegration
} from "@/Contracts";
import {
	Product,
	ProductSource,
	ProductSearchRequest,
	ItemSearchCursor,
	ProductMetaInfo,
	FeatureFilter,
	noOfDistributorsIntegrated,
	ProductType,
	SelfCatalogFilters,
	PricingSearchRequest,
	ETILIZE_PAGE_SIZE,
	SortOptions,
	AmazonFilterProps,
	AmazonRefinementsFilters,
	AmazonProductAppliedFilters,
	Distributor,
	distributors as DistributorsList,
	UOM
} from "@/Contracts/Products";

import {
	QuoteProduct,
	MultipleQuoteProductRequest
} from "@/Contracts/ProposalBuilder/Block";

import {
	searchProducts,
	searchPricing,
	searchSelfProductPricing
} from "@/Services/Products";
import ProductCatalogResultRow from "../../../../ProductsPage/Drawers/ProductCatalogResultRow/ProductCatalogResultRow";
import BlocksActionCreators from "@/ProposalBuilder/store/actions/Blocks";
import ItemFiltersMenu from "../DocumentProductDrawersComponents/ItemFilterMenu/ItemFiltersMenu";
import { SearchOutlined } from "@ant-design/icons";
import AddProductDrawerV2 from "@pages/Drawers/Products/Product";
import ZTypography from "@atoms/ZTypography";

import { useFeatureFlag } from "@/Hooks/useFeature";
import ZImage from "@atoms/ZImage";
import ZMessage from "@molecules/ZMessage";
import { cache } from "@/Contracts";
import { isEtilizeFiltersDropped } from "@/Components/Utils";
import {
	AllRolePermissions,
	Languages,
	PricingPlanNames,
	PricingAddOnEnum,
	UserRole
} from "@/Contracts/Users";
import ZFeatureAccess from "@atoms/ZFeatureAccess";
import ZUpdateMandatoryFieldsForQuoteBlockDrawer from "@templates/ZDocuments/ZUpdateMandatoryFieldsForQuoteBlockDrawer";
import ZUpdateProductCatalogResultColumn from "@templates/ZProductDetails/ZUpdateProductCatalogResultColumn";
import { EProductDrawerState } from "@pages/Drawers/Products/Product/interface";
import {
	constructProductIdToPricingMapping,
	getCustomDistributorProducts,
	getPreferredPricingForProduct,
	getVendorProducts
} from "@/V2Utils";
import ZTable from "@organisms/ZTable";
import usePermissions from "@/Hooks/usePermissions";
import { Modules, ModulePermission } from "@/Contracts/Permission";
import { VendorSubscriptionStatus } from "@/Contracts/Marketplace/Vendor";
import { GlobalState } from "@/Reducers/interface";
import { proposalBuilderStore } from "@/ProposalBuilder/store";
import { ProductsActionCreators } from "@/Actions/Products";
import { IntegrateAmazonForm } from "../DocumentProductDrawersComponents/AmazonIntegrateForm";
import ZButton from "@atoms/ZButton";
import { useFeatureAccess } from "@/Hooks/useFeatureAccess";
import UsersActionCreators from "@/Actions/User";

const { ZText } = ZTypography;

export const mapStateToProps = (state: GlobalState) => ({
	distributorsIntegrated:
		noOfDistributorsIntegrated(state.user.userCompany.integrations) > 0,
	isDickerDataIntegrated: !!state.user.userCompany.integrations.dicker_data,
	isTechDataIntegrated: !!state.user.userCompany.integrations.tech_data,
	isSynnexIntegrated: !!state.user.userCompany.integrations.synnex,
	currentUserId: state.user.userData.id,
	vendorProgramDetails: state.marketplace.vendorProgamDetails,
	userCompany: state.user.userCompany,
	isIcecatLocaleFR:
		state.user.userCompany.settings.icecat_locale === EtilizeLocale.FR,
	isIcecatLocaleUS:
		state.user.userCompany.settings.icecat_locale === EtilizeLocale.US,
	isFrenchLanguage:
		state.user.userCompany.settings.language === Languages.FRENCH,
	isAmazonDistributorIntegrated:
		!!state.user.userCompany.integrations.amazon_business,
	customDistributors: state.user.userCompany.integrations.custom_distributor,
	isInternalUser: state.user.billingInfo.is_internal,
	connectedSysDistributors: DistributorsList.filter(
		distributor =>
			state.user.userCompany.integrations[distributor] !== null &&
			distributor !== Distributor.CustomDistributor
	)
});

export const mapDispatchToProps = (
	dispatch: ThunkDispatch<GlobalState, any, Action>
) => ({
	addMultipleProductsInQuoteBlockSection: (
		request: MultipleQuoteProductRequest
	) =>
		proposalBuilderStore.dispatch(
			BlocksActionCreators.addMultipleProductsInQuoteBlockSection(request)
		),
	updateSelectedProduct: (selectedProduct: Product) =>
		proposalBuilderStore.dispatch(
			ProductsActionCreators.setSelectedEtilizeProduct(selectedProduct)
		),
	updateAmazonAppliedFilters: (
		amazonAppliedFilters: AmazonProductAppliedFilters
	) =>
		dispatch(
			UsersActionCreators.updateAmazonProductAppliedFilter(
				amazonAppliedFilters
			)
		)
});
export interface Props
	extends ReturnType<typeof mapDispatchToProps>,
		ReturnType<typeof mapStateToProps> {
	readonly onSubmit: (
		selectedProducts: Product[],
		productVsPricing: Record<string, string | null>,
		addingToBundle?: boolean
	) => void;
	readonly onClose?: ((e: any) => void) | undefined;
	readonly isLoading: boolean;
	readonly excludeBundles?: boolean;
	readonly itemType?: string;
	readonly isFromProductsPage: boolean;
	readonly configureDrawer?: ReactNode;
	readonly unfilledSelectedQuoteProductIds?: string[];
	readonly removeQuoteProducts?: (quoteProductIds: string[]) => void;
	readonly resetQuoteProducts?: () => void;
	readonly configureQuoteProduct?: (productId: string) => void;
	readonly isEtilizePricingOn?: boolean;
	readonly marketplaceFlag?: boolean;
	readonly showPartnerAlignFeaturesFlag?: boolean;
	readonly source?: ProductSource | null;
	readonly createProductPermission?: AllRolePermissions[];
	readonly productVsPricing?: Record<string, string | null>;
	readonly isIcecatIntegrationEnabled?: boolean;
	readonly isIcecatEnabledForAll?: boolean;
	readonly customDistributerInSearchDocumentProductCatalogueFlag?: boolean;
	readonly enableCustomDistributorSeparateTabFlag?: boolean;
	readonly customDistributors: CustomDistributorIntegration[] | null;
	readonly hasPermissionForAmazonDistributor?: boolean;
	readonly isCDSearchEnhancementEnabled?: boolean;
	readonly automationFilterV2Flag?: boolean;
	readonly openImportDrawer?: () => void;
	readonly isUnifiedSearchEnabled?: boolean;
}

export interface State extends DefaultTableFilterSortSearchParameters {
	readonly loading: boolean;
	readonly pricingLoading: boolean;
	readonly hasTriggeredPagination: boolean;
	readonly dataSource: Product[];
	readonly metaInfo: ProductMetaInfo;
	readonly selectedProductList: Product[];
	readonly currentItemSource: ProductSource;
	readonly currentCursor: ItemSearchCursor | null;
	readonly manufacturerFilters: string[];
	readonly categoryFilters: string[];
	readonly featureFilters: FeatureFilter[];
	readonly filterByConnectedDistributors: boolean;
	readonly excludeOutOfStock: boolean;
	readonly excludeDropShipWH: boolean;
	readonly productVsPricing: Record<string, string | null>;
	readonly selectedProductType: string[];
	readonly selectedVendors: string[];
	readonly selectedSyncSource: string[];
	readonly lastFetchedItemsFromPricing: string[];
	readonly selfCatalogFilters: SelfCatalogFilters;
	readonly createProductButtonVisible: boolean;

	readonly sortBy: SortOptions | undefined;
	readonly amazonFilterState?: AmazonFilterProps;
	readonly customDistributorsFilters?: string[];
	readonly selectedDistributorsV2: {
		system: string[];
		custom: string[];
	};
}

const defaultStateValue = (_props: Props) => {
	return {
		loading: false,
		dataSource: new Array<Product>(),
		metaInfo: new ProductMetaInfo(),
		selectedProductList: new Array<Product>(),
		currentItemSource:
			cache.get("product_search_content_source", true) ??
			ProductSource.Self,
		currentCursor: null,
		manufacturerFilters: [],
		categoryFilters: [],
		featureFilters: [],
		filterByConnectedDistributors: false,
		excludeOutOfStock: false,
		excludeDropShipWH: false,
		productVsPricing: {},
		selectedProductType: [],
		selectedVendors: [],
		selectedSyncSource: [],

		selfCatalogFilters: new SelfCatalogFilters(),
		selectedDistributorsV2: {
			system: [],
			custom: []
		},
		...DefaultTableFilterSortSearch
	};
};

class SearchDocumentProductCatalog extends Component<Props, State> {
	sortDataSource = (
		data: Product[],
		sortBy: SortOptions | undefined
	): Product[] => {
		if (!sortBy) {
			return data;
		}
		const sortedData = [...data].sort((a: Product, b: Product) => {
			if (sortBy === SortOptions.NameAToZ) {
				return a.name.localeCompare(b.name);
			}
			if (sortBy === SortOptions.NameZToA) {
				return b.name.localeCompare(a.name);
			}
			if (sortBy === SortOptions.CostPriceHighToLow) {
				const maxB = Math.max(...b.pricing.map(p => p.cost_price ?? 0));
				const maxA = Math.max(...a.pricing.map(p => p.cost_price ?? 0));
				return maxB - maxA;
			}
			if (sortBy === SortOptions.CostPriceLowToHigh) {
				const minA = Math.min(...a.pricing.map(p => p.cost_price ?? 0));
				const minB = Math.min(...b.pricing.map(p => p.cost_price ?? 0));
				return minA - minB;
			}
			if (sortBy === SortOptions.SellPriceHighToLow) {
				const maxB = Math.max(...b.pricing.map(p => p.sell_price ?? 0));
				const maxA = Math.max(...a.pricing.map(p => p.sell_price ?? 0));
				return maxB - maxA;
			}
			if (sortBy === SortOptions.SellPriceLowToHigh) {
				const minA = Math.min(...a.pricing.map(p => p.sell_price ?? 0));
				const minB = Math.min(...b.pricing.map(p => p.sell_price ?? 0));
				return minA - minB;
			}
			return 0;
		});

		const isSellPriceSort =
			sortBy === SortOptions.SellPriceHighToLow ||
			sortBy === SortOptions.SellPriceLowToHigh;
		const isCostPriceSort =
			sortBy === SortOptions.CostPriceHighToLow ||
			sortBy === SortOptions.CostPriceLowToHigh;

		if (isSellPriceSort || isCostPriceSort) {
			const pricingSelections: Record<string, string | null> = {};

			sortedData.forEach(product => {
				const pricingList = [...product.pricing];
				if (!pricingList.length) {
					pricingSelections[product.id] = null;
					return;
				}

				const selectedPricing = pricingList.sort((a, b) => {
					const priceA = isSellPriceSort
						? a.sell_price ?? 0
						: a.cost_price ?? 0;
					const priceB = isSellPriceSort
						? b.sell_price ?? 0
						: b.cost_price ?? 0;
					const isHighToLow =
						sortBy === SortOptions.SellPriceHighToLow ||
						sortBy === SortOptions.CostPriceHighToLow;
					return isHighToLow ? priceB - priceA : priceA - priceB;
				})[0];

				pricingSelections[product.id] = selectedPricing?.id ?? null;
			});

			this.setState(prevState => ({
				productVsPricing: {
					...prevState.productVsPricing,
					...pricingSelections
				}
			}));
		}

		return sortedData;
	};
	state: State = {
		loading: false,
		pricingLoading: false,
		hasTriggeredPagination: false,
		dataSource: new Array<Product>(),
		metaInfo: new ProductMetaInfo(),
		selectedProductList: new Array<Product>(),
		currentItemSource:
			this.props.source ??
			cache.get("product_search_content_source", true) ??
			ProductSource.Self,
		currentCursor: null,
		manufacturerFilters: [],
		categoryFilters: [],
		featureFilters: [],
		filterByConnectedDistributors: this.props.isDickerDataIntegrated
			? false
			: this.props.distributorsIntegrated,
		excludeOutOfStock: false,
		excludeDropShipWH: false,
		productVsPricing: {},
		selectedProductType: [],
		selectedVendors: [],
		selectedSyncSource: [],
		lastFetchedItemsFromPricing: [],

		createProductButtonVisible: false,

		selfCatalogFilters: new SelfCatalogFilters(),

		...DefaultTableFilterSortSearch,
		sortBy: undefined,
		amazonFilterState: {
			includeOutOfStockProducts: [],
			eligibleForFreeShipping: false,
			amazonPrimeEligible: false,
			amazonProductCategory: [],
			amazonProductSubCategory: [],
			amazonProductDeliveryDay: []
		},
		customDistributorsFilters:
			this.props.customDistributors?.map(distributor => distributor.id) ??
			[],
		selectedDistributorsV2: {
			system:
				this.props.isCDSearchEnhancementEnabled &&
				(this.props.isDickerDataIntegrated
					? false
					: this.props.distributorsIntegrated)
					? this.props.connectedSysDistributors
					: [],
			custom:
				this.props.isCDSearchEnhancementEnabled &&
				(this.props.isDickerDataIntegrated
					? false
					: this.props.distributorsIntegrated)
					? this.props.customDistributors?.map(
							distributor => distributor.id
					  ) ?? []
					: []
		}
	};

	tableContainerRef = React.createRef<HTMLDivElement>();
	searchInputRef = React.createRef<any>();

	loadingRef = false;

	onPricingSelect = (productId: string, selectedPricingId?: string) => {
		this.setState({
			productVsPricing: {
				...this.state.productVsPricing,
				[productId]: selectedPricingId || null
			}
		});

		// Update product name and description for custom distributor products when pricing changes
		if (productId.startsWith("custom_distributor:")) {
			this.updateProductNameAndDescriptionForCustomDistributor(
				productId,
				selectedPricingId
			);
		}
	};

	updateProductNameAndDescriptionForCustomDistributor = (
		productId: string,
		selectedPricingId?: string
	) => {
		if (!selectedPricingId) return;

		const updatedDataSource = this.state.dataSource.map(product => {
			if (product.id === productId) {
				const selectedPricing = product.pricing.find(
					p => p.id === selectedPricingId
				);

				if (selectedPricing) {
					// For custom distributors, use the pricing's name first, then fall back to product name
					// This ensures the specific pricing name is displayed when selected
					const updatedName = selectedPricing.name || product.name;
					const updatedDescription =
						selectedPricing.description || product.description;

					return {
						...product,
						name: updatedName,
						description: updatedDescription
					};
				}
			}
			return product;
		});

		// Also update selectedProductList if the product is currently selected
		const updatedSelectedProductList = this.state.selectedProductList.map(
			selectedProduct => {
				if (selectedProduct.id === productId) {
					const selectedPricing = selectedProduct.pricing.find(
						p => p.id === selectedPricingId
					);

					if (selectedPricing) {
						const updatedName =
							selectedPricing.name || selectedProduct.name;
						const updatedDescription =
							selectedPricing.description ||
							selectedProduct.description;

						return {
							...selectedProduct,
							name: updatedName,
							description: updatedDescription
						};
					}
				}
				return selectedProduct;
			}
		);

		this.setState({
			dataSource: updatedDataSource,
			selectedProductList: updatedSelectedProductList
		});
	};

	removeItemsFromUpdateMandatoryFieldsDrawer = (products: Product[]) => {
		this.props.removeQuoteProducts?.(products.map(product => product.id));
		this.setState(prevState => ({
			selectedProductList: prevState.selectedProductList.filter(
				product =>
					!products.some(
						productToBeRemoved =>
							product.id === productToBeRemoved.id
					)
			)
		}));
	};

	renderProductColumn =
		(showUpdateMandatoryFieldsColumn: boolean) =>
		(_text: unknown, record: Product): ReactNode => {
			const pricingLoading =
				this.state.lastFetchedItemsFromPricing.includes(record.id)
					? true
					: !this.state.productVsPricing[record.id]?.length;
			return (
				<ProductCatalogResultRow
					record={record}
					showPricing={!showUpdateMandatoryFieldsColumn}
					selectedPricingId={this.state.productVsPricing[record.id]}
					onPricingChange={this.onPricingSelect}
					isFromProductsPage={this.props.isFromProductsPage}
					currentItemSource={this.state.currentItemSource}
					pricingLoading={this.state.pricingLoading && pricingLoading}
					showUpdateMandatoryFieldsColumn={
						showUpdateMandatoryFieldsColumn
					}
				>
					{showUpdateMandatoryFieldsColumn && (
						<ZUpdateProductCatalogResultColumn
							onUpdateFieldClick={() =>
								this.props.configureQuoteProduct?.(record.id)
							}
							onRemoveItem={() =>
								this.removeItemsFromUpdateMandatoryFieldsDrawer(
									[record]
								)
							}
							updated={
								!this.props.unfilledSelectedQuoteProductIds?.includes(
									record.id
								)
							}
							selectedPricingId={
								this.state.productVsPricing[record.id]
							}
							record={record}
							showPricing={showUpdateMandatoryFieldsColumn}
							currentItemSource={this.state.currentItemSource}
						/>
					)}
				</ProductCatalogResultRow>
			);
		};

	productColumns: ColumnType<Product>[] = [
		{
			dataIndex: "name",
			key: "name",
			render: this.renderProductColumn(false)
		}
	];

	resetState = () => {
		this.setState({ ...defaultStateValue });
		this.resetCustomFilters(true);
	};

	handleTableSearch = (_selectedKeys?: ReactText[], confirm?: () => void) => {
		confirm && confirm();
	};

	handleTableReset = (
		clearFilters: ((selectedKeys: string[]) => void) | undefined
	) => {
		clearFilters && clearFilters([""]);
	};

	handleCreateProductClick = () => {
		this.setState({ createProductButtonVisible: true });
	};

	handleOnClose = () => this.setState({ createProductButtonVisible: false });

	onClose = (e: any) => {
		// Clear filters for custom distributor when drawer is closed
		if (this.state.currentItemSource === ProductSource.CustomDistributor) {
			this.setState({
				manufacturerFilters: [],
				categoryFilters: [],
				featureFilters: [],
				excludeOutOfStock: false,
				excludeDropShipWH: false,
				filterByConnectedDistributors: false,
				customDistributorsFilters: [],
				selectedDistributorsV2: {
					system: [],
					custom: []
				},
				dataSource: [],
				currentCursor: null,
				productVsPricing: {},
				...DefaultTableFilterSortSearch
			});
		}

		// Call the parent's onClose if provided
		this.props.onClose?.(e);
	};

	stopPropagation = ($event: React.MouseEvent<HTMLElement, MouseEvent>) => {
		$event && $event.stopPropagation();
	};

	onProductSourceChange = (currentItemSource: ProductSource) => {
		cache.save("product_search_content_source", currentItemSource);
		this.setState({
			currentItemSource,
			currentCursor: null,
			metaInfo: new ProductMetaInfo(),
			selectedProductList: [],
			selfCatalogFilters: new SelfCatalogFilters(),
			dataSource: [],
			productVsPricing: {}
		});
		this.resetCustomFilters(true);

		if (
			!this.props.isAmazonDistributorIntegrated &&
			currentItemSource === ProductSource.Amazon
		) {
			return;
		}

		const isEtilizeOrIcecat =
			currentItemSource === ProductSource.Etilize ||
			currentItemSource === ProductSource.Icecat;

		const isCustomDistributor =
			currentItemSource === ProductSource.CustomDistributor;

		if (
			(isEtilizeOrIcecat || isCustomDistributor) &&
			!this.state.currentKeywords?.length
		) {
			return;
		}

		const itemTypeFilter = this.findProductType(this.props.itemType);
		const shouldFetchRealtimePricing =
			this.state.currentItemSource !== ProductSource.Self;

		const filterByConnectedDistributors =
			(currentItemSource === ProductSource.Etilize ||
				currentItemSource === ProductSource.Icecat) &&
			this.props.distributorsIntegrated &&
			!this.props.isDickerDataIntegrated;

		const source =
			currentItemSource === ProductSource.Icecat
				? (this.props.isIcecatIntegrationEnabled &&
						(this.props.isIcecatLocaleFR ||
							(this.props.isIcecatLocaleUS &&
								this.props.isFrenchLanguage))) ||
				  this.props.isIcecatEnabledForAll
					? ProductSource.Icecat
					: ProductSource.Etilize
				: currentItemSource;
		const searchRequest = ProductSearchRequest.constructSearchRequest(
			this.state.currentKeywords,
			source,
			null,
			shouldFetchRealtimePricing,
			filterByConnectedDistributors,
			(this.state.selectedDistributorsV2?.system as Distributor[]) || [],
			this.state.customDistributorsFilters?.length
				? this.state.customDistributorsFilters
				: this.state.selectedDistributorsV2?.custom,
			false,
			false,
			[],
			[],
			[],
			itemTypeFilter,
			new SelfCatalogFilters(),
			false,
			this.state.sortBy
		);
		this.searchProducts(searchRequest, false, true);
	};

	shouldUseLazyLoad = (
		productSearchRequest: ProductSearchRequest
	): boolean => {
		if (
			(productSearchRequest.filter_by_connected_distributors &&
				productSearchRequest.exclude_out_of_stock_products) ||
			!this.props.isEtilizePricingOn
		)
			return false;
		return true;
	};

	onProductSearchKeywordChange = (currentKeywords: string) => {
		let itemTypeFilter = this.state.selectedProductType;
		if (this.props.isFromProductsPage) {
			itemTypeFilter = this.findProductType(this.props.itemType);
		}
		this.setState({ currentKeywords, currentCursor: null });

		// Reset scroll position to top for new search
		setTimeout(() => {
			const drawer: HTMLElement | null | undefined =
				this.tableContainerRef.current?.querySelector(
					".table-page-container .product-table .ant-table"
				);
			if (drawer) {
				drawer.scrollTop = 0;
			}
		}, 100);

		const shouldFetchRealtimePricing =
			this.state.currentItemSource !== ProductSource.Self;
		if (shouldFetchRealtimePricing) {
			this.resetCustomFilters(false);
		}

		const isSourceAmazon =
			this.state.currentItemSource === ProductSource.Amazon;
		if (isSourceAmazon) {
			this.setState({
				amazonFilterState: {
					includeOutOfStockProducts: [],
					eligibleForFreeShipping: false,
					amazonPrimeEligible: false,
					amazonProductCategory: [],
					amazonProductSubCategory: [],
					amazonProductDeliveryDay: []
				}
			});
			const appliedFilters = {
				categories: [],
				sub_categories: [],
				availability_options: []
			};
			this.props.updateAmazonAppliedFilters(appliedFilters);
		}

		const source =
			this.state.currentCursor?.current_source ??
			(this.state.currentItemSource === ProductSource.Icecat
				? (this.props.isIcecatIntegrationEnabled &&
						(this.props.isIcecatLocaleFR ||
							(this.props.isIcecatLocaleUS &&
								this.props.isFrenchLanguage))) ||
				  this.props.isIcecatEnabledForAll
					? ProductSource.Icecat
					: ProductSource.Etilize
				: this.state.currentItemSource);

		const searchRequest = ProductSearchRequest.constructSearchRequest(
			currentKeywords,
			source,
			null,
			shouldFetchRealtimePricing,
			(this.state.currentItemSource === ProductSource.Etilize ||
				this.state.currentItemSource === ProductSource.Icecat) &&
				this.state.filterByConnectedDistributors,
			(this.state.selectedDistributorsV2?.system as Distributor[]) || [],
			this.state.customDistributorsFilters?.length
				? this.state.customDistributorsFilters
				: this.state.selectedDistributorsV2?.custom,
			this.state.currentItemSource === ProductSource.Etilize ||
				this.state.currentItemSource === ProductSource.Icecat
				? this.state.excludeOutOfStock
				: this.state.currentItemSource === ProductSource.Amazon,
			(this.state.currentItemSource === ProductSource.Etilize ||
				this.state.currentItemSource === ProductSource.Icecat) &&
				this.state.excludeDropShipWH,
			[],
			[],
			[],
			itemTypeFilter,
			this.state.selfCatalogFilters,
			false,
			this.state.sortBy
		);
		this.searchProducts(searchRequest, false, true);
	};

	findProductType = (itemType: string | undefined) => {
		if (itemType) {
			const fetchProducts = filter(ProductType, product => {
				return product !== itemType;
			});
			return fetchProducts;
		}
		return [];
	};

	_isMounted = false;

	componentDidMount() {
		this._isMounted = true;
		// Clear filters when component mounts with CustomDistributor source
		if (this.state.currentItemSource === ProductSource.CustomDistributor) {
			this.setState({
				manufacturerFilters: [],
				categoryFilters: [],
				featureFilters: [],
				filterByConnectedDistributors: false,
				customDistributorsFilters: [],
				selectedDistributorsV2: {
					system: [],
					custom: []
				},
				excludeOutOfStock: false,
				excludeDropShipWH: false,
				selectedProductType: [],
				selfCatalogFilters: new SelfCatalogFilters()
			});
		}

		if (
			!this.props.isAmazonDistributorIntegrated &&
			this.state.currentItemSource === ProductSource.Amazon
		) {
			return;
		}

		const isEtilizeOrIcecat =
			this.state.currentItemSource === ProductSource.Etilize ||
			this.state.currentItemSource === ProductSource.Icecat;

		const isCustomDistributor =
			this.state.currentItemSource === ProductSource.CustomDistributor;

		if (
			(isEtilizeOrIcecat || isCustomDistributor) &&
			!this.state.currentKeywords?.length
		) {
			return;
		}

		const source =
			this.state.currentCursor?.current_source ??
			(this.state.currentItemSource === ProductSource.Icecat
				? (this.props.isIcecatIntegrationEnabled &&
						(this.props.isIcecatLocaleFR ||
							(this.props.isIcecatLocaleUS &&
								this.props.isFrenchLanguage))) ||
				  this.props.isIcecatEnabledForAll
					? ProductSource.Icecat
					: ProductSource.Etilize
				: this.state.currentItemSource);

		const itemTypeFilter = this.findProductType(this.props.itemType);
		const shouldFetchRealtimePricing =
			this.state.currentItemSource !== ProductSource.Self;
		const searchRequest = ProductSearchRequest.constructSearchRequest(
			this.state.currentKeywords,
			source,
			null,
			shouldFetchRealtimePricing,
			(this.state.currentItemSource === ProductSource.Etilize ||
				this.state.currentItemSource === ProductSource.Icecat) &&
				this.props.distributorsIntegrated,
			(this.state.selectedDistributorsV2?.system as Distributor[]) || [],
			this.state.customDistributorsFilters?.length
				? this.state.customDistributorsFilters
				: this.state.selectedDistributorsV2?.custom,
			this.state.currentItemSource === ProductSource.Etilize ||
				this.state.currentItemSource === ProductSource.Icecat
				? this.props.distributorsIntegrated
				: this.state.currentItemSource === ProductSource.Amazon,
			isEtilizeOrIcecat && this.props.distributorsIntegrated,
			[],
			[],
			[],
			itemTypeFilter,
			this.state.selfCatalogFilters,
			false,
			this.state.sortBy
		);
		this.searchProducts(searchRequest, false, true);
		this.addScrollListener();
	}
	componentWillUnmount() {
		this._isMounted = false;
		this.removeScrollListener();
	}

	componentDidUpdate(prevProps: Props, prevState: State) {
		if (
			this.props.isIcecatIntegrationEnabled !==
			prevProps.isIcecatIntegrationEnabled
		) {
			this.setState({
				currentItemSource:
					this.state.currentItemSource === ProductSource.Etilize
						? ProductSource.Icecat
						: this.state.currentItemSource
			});
		}

		// Auto-pagination for small result sets - but only if not triggered by scroll
		if (
			this.state.dataSource.length < ETILIZE_PAGE_SIZE &&
			this.state.currentCursor?.current_page_no !==
				prevState.currentCursor?.current_page_no &&
			!!this.state.currentCursor &&
			!this.state.hasTriggeredPagination // Only auto-paginate if scroll didn't trigger it
		) {
			const shouldFetchRealtimePricing =
				this.state.currentItemSource !== ProductSource.Self;
			const source =
				this.state.currentCursor?.current_source ??
				(this.state.currentItemSource === ProductSource.Icecat
					? (this.props.isIcecatIntegrationEnabled &&
							(this.props.isIcecatLocaleFR ||
								(this.props.isIcecatLocaleUS &&
									this.props.isFrenchLanguage))) ||
					  this.props.isIcecatEnabledForAll
						? ProductSource.Icecat
						: ProductSource.Etilize
					: this.state.currentItemSource);
			const searchRequest = ProductSearchRequest.constructSearchRequest(
				this.state.currentKeywords,
				source,
				this.state.currentCursor,
				shouldFetchRealtimePricing,
				this.state.filterByConnectedDistributors,
				(this.state.selectedDistributorsV2?.system as Distributor[]) ||
					[],
				this.state.customDistributorsFilters?.length
					? this.state.customDistributorsFilters
					: this.state.selectedDistributorsV2?.custom,
				this.state.excludeOutOfStock,
				this.state.excludeDropShipWH,
				this.state.manufacturerFilters,
				this.state.categoryFilters,
				[],
				[],
				new SelfCatalogFilters(),
				false,
				this.state.sortBy
			);
			this.searchProducts(searchRequest, true, true);
		}
	}

	searchProducts = async (
		productSearchRequest: ProductSearchRequest,
		appendResults: boolean,
		updateMetaInfo: boolean
	) => {
		if (!appendResults) {
			this.setState({ loading: true, hasTriggeredPagination: false });
		} else {
			this.setState({ loading: true });
		}
		this.loadingRef = true;
		try {
			const isRequestForLazyLoad =
				this.shouldUseLazyLoad(productSearchRequest);
			const productsSearchResponse = await searchProducts({
				...productSearchRequest,
				is_request_for_lazy_load: isRequestForLazyLoad
			});
			if (
				isEtilizeFiltersDropped(
					productSearchRequest,
					productsSearchResponse
				)
			)
				ZMessage.error(
					"Some filter(s) were dropped because no products were found under them."
				);

			let dataSourceValue: Product[] = [];

			if (appendResults && !!this.state.dataSource?.length) {
				dataSourceValue = this.state.dataSource.concat(
					productsSearchResponse.data
				);
			} else {
				dataSourceValue = productsSearchResponse.data;
			}

			if (this.state.currentItemSource === ProductSource.Icecat) {
				dataSourceValue = this.sortDataSource(
					dataSourceValue,
					this.state.sortBy
				);
			}

			// Enhance initial custom distributor products with vendor information for each pricing plan
			dataSourceValue = dataSourceValue.map(product => {
				if (
					product.id.startsWith("custom_distributor:") &&
					product.pricing &&
					product.pricing.length > 0
				) {
					// For custom distributor products from initial search, enhance each pricing plan with product-level info as fallback
					const enhancedPricing = product.pricing.map(
						(pricing: any) => {
							return {
								...pricing,
								// Use the pricing's own name if it exists, otherwise fall back to product name
								// This preserves individual pricing plan names while providing vendor info as fallback
								vendor_name:
									pricing.vendor_name || product.name,
								name: pricing.name || product.name,
								description:
									pricing.description || product.description
							};
						}
					);

					return {
						...product,
						pricing: enhancedPricing
					};
				}
				return product;
			});

			const pricingMapForDataSource =
				constructProductIdToPricingMapping(dataSourceValue);
			const productVsPricingInitialValue = Object.keys(
				pricingMapForDataSource
			).reduce(
				(map, productId) => {
					if (!map[productId] || pricingMapForDataSource[productId]) {
						map[productId] = pricingMapForDataSource[productId];
					}
					return map;
				},
				{ ...this.state.productVsPricing }
			);
			if (!this._isMounted) return;

			if (appendResults) {
				this.setState({
					dataSource: dataSourceValue,
					currentCursor: productsSearchResponse.next,
					productVsPricing: productVsPricingInitialValue,
					loading: false,
					hasTriggeredPagination: false
				});
			} else {
				this.setState({
					dataSource: dataSourceValue,
					currentCursor: productsSearchResponse.next,
					productVsPricing: productVsPricingInitialValue,
					loading: false
				});
			}
			this.loadingRef = false;

			// Ensure scroll listener is attached after search completes
			this.addScrollListener();

			// Check for custom_distributor products regardless of source and handle their pricing
			// Skip if current source is CustomDistributor as it's handled separately below
			// Use the current search response data to get pricing for newly fetched products only
			const currentResponseData = appendResults
				? productsSearchResponse.data
				: dataSourceValue;
			const customDistributorProductsInResponse =
				currentResponseData.filter(product =>
					product.id.startsWith("custom_distributor:")
				);

			if (
				customDistributorProductsInResponse.length > 0 &&
				this.state.currentItemSource !== ProductSource.CustomDistributor
			) {
				try {
					// Only show loading for current page items (most recent batch)
					const currentPageItems = appendResults
						? customDistributorProductsInResponse
								.slice(-ETILIZE_PAGE_SIZE)
								.map(product => product.id)
						: customDistributorProductsInResponse.map(
								product => product.id
						  );
					this.setState({
						pricingLoading: true,
						lastFetchedItemsFromPricing: currentPageItems
					});
					const customDistributorProductsForPricing =
						getCustomDistributorProducts(
							customDistributorProductsInResponse
						);
					const customDistributorPricingRequest =
						PricingSearchRequest.constructSearchRequest(
							[],
							[],
							customDistributorProductsForPricing,
							this.state.excludeDropShipWH,
							productSearchRequest.q
						);

					const pricingResponse = await searchPricing(
						customDistributorPricingRequest
					);
					const responseDataWithPricing = pricingResponse?.data || [];

					const productVsPricingMap = responseDataWithPricing.reduce(
						(map, product) => {
							map[product.id] = product.pricing;
							return map;
						},
						{}
					);

					const updatedDataSource = dataSourceValue.map(product => {
						const additionalProductPricing =
							productVsPricingMap[product.id];

						// Check if this product has updated data in the pricing response
						const pricingResponseProduct =
							responseDataWithPricing.find(
								p => p.id === product.id
							);

						if (
							additionalProductPricing &&
							additionalProductPricing.length > 0
						) {
							// Always merge existing pricing with additional pricing for all products
							const existingPricing = product.pricing || [];
							const existingPricingIds = new Set(
								existingPricing.map(p => p.id).filter(id => id)
							);

							// Filter out duplicate pricing entries based on pricing ID
							const uniqueAdditionalPricing =
								additionalProductPricing.filter(
									(p: any) =>
										!p.id || !existingPricingIds.has(p.id)
								);

							// For additional pricing from custom distributors, use the root level name and description from API response
							// This ensures each additional pricing displays the product-level information from the pricing API response
							const enhancedAdditionalPricing =
								uniqueAdditionalPricing.map((pricing: any) => {
									return {
										...pricing,
										// Use the product's root level name and description from the pricing API response
										// This comes from the pricingResponseProduct, not the individual pricing object
										name:
											pricingResponseProduct?.name ||
											pricing.name,
										description:
											pricingResponseProduct?.description ||
											pricing.description
									};
								});

							// Combine both existing pricing from search response and enhanced additional pricing
							product.pricing = [
								...existingPricing,
								...enhancedAdditionalPricing
							];

							// Also update the base product for consistency
							if (pricingResponseProduct) {
								product.name =
									pricingResponseProduct.name || product.name;
								product.description =
									pricingResponseProduct.description ||
									product.description;
							}
						}
						return product;
					});

					const newProductVsPricingIdMap =
						constructProductIdToPricingMapping(updatedDataSource);

					// Update product name and description for custom distributor products based on selected pricing
					const finalUpdatedDataSource = updatedDataSource.map(
						product => {
							if (product.id.startsWith("custom_distributor:")) {
								const selectedPricingId =
									newProductVsPricingIdMap[product.id];

								if (selectedPricingId) {
									const selectedPricing =
										product.pricing.find(
											p => p.id === selectedPricingId
										);

									if (selectedPricing) {
										// For custom distributors, use the pricing's name first, then fall back to product name
										const updatedName =
											selectedPricing.name ||
											product.name;
										const updatedDescription =
											selectedPricing.description ||
											product.description;

										return {
											...product,
											name: updatedName,
											description: updatedDescription
										};
									}
								}
							}
							return product;
						}
					);

					this.setState({
						dataSource: finalUpdatedDataSource,
						productVsPricing: {
							...this.state.productVsPricing,
							...newProductVsPricingIdMap
						}
					});
				} catch (error) {
					console.error(
						"Error fetching custom distributor pricing:",
						error
					);
				} finally {
					this.setState({
						pricingLoading: false,
						lastFetchedItemsFromPricing: []
					});
				}
			}

			if (this.state.currentItemSource === ProductSource.Self) {
				try {
					this.setState({ pricingLoading: true });
					const itemIds = productsSearchResponse.data.map(
						product => product.id
					);
					// Only show loading for current page items (most recent batch)
					const currentPageItems = appendResults
						? itemIds.slice(-ETILIZE_PAGE_SIZE)
						: itemIds;
					this.setState({
						lastFetchedItemsFromPricing: currentPageItems
					});
					const pricingList = await searchSelfProductPricing(itemIds);

					const tempDataSource = this.state.dataSource;

					const dataSourceWithPricing = tempDataSource.map(
						product => {
							const pricing =
								pricingList.data.find(pricingDetail => {
									return pricingDetail.item_id === product.id;
								})?.pricing || product.pricing;

							return {
								...product,
								pricing: pricing
							};
						}
					);

					const productVsPricing = {
						...this.state.productVsPricing,
						...constructProductIdToPricingMapping(
							dataSourceWithPricing
						)
					};

					this.setState({
						dataSource: dataSourceWithPricing,
						productVsPricing
					});
				} catch (error) {
					console.error(error);
				} finally {
					this.setState({ pricingLoading: false });
				}
			} else if (
				this.state.currentItemSource === ProductSource.CustomDistributor
			) {
				try {
					// Use the current search response data to get pricing for newly fetched products only
					const currentCustomDistributorResponseData = appendResults
						? productsSearchResponse.data
						: dataSourceValue;
					const customDistributorProducts =
						currentCustomDistributorResponseData.filter(product =>
							product.id.startsWith("custom_distributor:")
						);
					// Only show loading for current page items (most recent batch)
					const currentPageItems = appendResults
						? customDistributorProducts
								.slice(-ETILIZE_PAGE_SIZE)
								.map(product => product.id)
						: customDistributorProducts.map(product => product.id);
					this.setState({
						pricingLoading: true,
						lastFetchedItemsFromPricing: currentPageItems
					});

					if (customDistributorProducts.length > 0) {
						const customDistributorProductsForPricing =
							getCustomDistributorProducts(
								customDistributorProducts
							);
						const customDistributorPricingRequest =
							PricingSearchRequest.constructSearchRequest(
								[],
								[],
								customDistributorProductsForPricing,
								this.state.excludeDropShipWH,
								productSearchRequest.q
							);

						const pricingResponse = await searchPricing(
							customDistributorPricingRequest
						);
						const responseDataWithPricing =
							pricingResponse?.data || [];

						const productVsPricingMap =
							responseDataWithPricing.reduce((map, product) => {
								map[product.id] = product.pricing;
								return map;
							}, {});

						const updatedDataSource = dataSourceValue.map(
							product => {
								const additionalProductPricing =
									productVsPricingMap[product.id];

								// Check if this product has updated data in the pricing response
								const pricingResponseProduct =
									responseDataWithPricing.find(
										p => p.id === product.id
									);

								if (
									additionalProductPricing &&
									additionalProductPricing.length > 0
								) {
									// Always merge existing pricing with additional pricing for all custom distributor products
									const existingPricing =
										product.pricing || [];
									const existingPricingIds = new Set(
										existingPricing
											.map(p => p.id)
											.filter(id => id)
									);

									// Filter out duplicate pricing entries based on pricing ID
									const uniqueAdditionalPricing =
										additionalProductPricing.filter(
											(p: any) =>
												!p.id ||
												!existingPricingIds.has(p.id)
										);

									// For additional pricing from custom distributors, use the root level name and description from API response
									// This ensures each additional pricing displays the product-level information from the pricing API response
									const enhancedAdditionalPricing =
										uniqueAdditionalPricing.map(
											(pricing: any) => {
												return {
													...pricing,
													// Use the product's root level name and description from the pricing API response
													// This comes from the pricingResponseProduct, not the individual pricing object
													name:
														pricingResponseProduct?.name ||
														pricing.name,
													description:
														pricingResponseProduct?.description ||
														pricing.description
												};
											}
										);

									// Combine both existing pricing from search response and enhanced additional pricing
									product.pricing = [
										...existingPricing,
										...enhancedAdditionalPricing
									];

									// Also update the base product for consistency
									if (pricingResponseProduct) {
										product.name =
											pricingResponseProduct.name ||
											product.name;
										product.description =
											pricingResponseProduct.description ||
											product.description;
									}
								}
								return product;
							}
						);

						const newProductVsPricingIdMap =
							constructProductIdToPricingMapping(
								updatedDataSource
							);

						// Update product name and description for custom distributor products based on selected pricing
						const finalUpdatedDataSource = updatedDataSource.map(
							product => {
								if (
									product.id.startsWith("custom_distributor:")
								) {
									const selectedPricingId =
										newProductVsPricingIdMap[product.id];

									if (selectedPricingId) {
										const selectedPricing =
											product.pricing.find(
												p => p.id === selectedPricingId
											);

										if (selectedPricing) {
											// For custom distributors, use the pricing's name first, then fall back to product name
											const updatedName =
												selectedPricing.name ||
												product.name;
											const updatedDescription =
												selectedPricing.description ||
												product.description;

											return {
												...product,
												name: updatedName,
												description: updatedDescription
											};
										}
									}
								}
								return product;
							}
						);

						this.setState({
							dataSource: finalUpdatedDataSource,
							productVsPricing: {
								...this.state.productVsPricing,
								...newProductVsPricingIdMap
							}
						});
					}
				} catch (error) {
					console.error(error);
				} finally {
					this.setState({
						pricingLoading: false,
						lastFetchedItemsFromPricing: []
					});
				}
			} else if (this.props.isEtilizePricingOn && isRequestForLazyLoad) {
				try {
					this.setState({ pricingLoading: true });
					const isIcecatEnabled =
						(this.props.isIcecatIntegrationEnabled &&
							(this.props.isIcecatLocaleFR ||
								(this.props.isIcecatLocaleUS &&
									this.props.isFrenchLanguage))) ||
						this.props.isIcecatEnabledForAll ||
						false;
					const dataWithoutPricing = dataSourceValue.filter(
						product =>
							!product.pricing.length &&
							!product.id.startsWith("custom_distributor:") &&
							((product?.icecat_skus_info && isIcecatEnabled) ||
								product?.etilize_skus_info)
					);
					// Only show loading for current page items (most recent batch)
					const currentPageItemsWithoutPricing = appendResults
						? dataWithoutPricing
								.slice(-ETILIZE_PAGE_SIZE)
								.map(data => data.id)
						: dataWithoutPricing.map(data => data.id);
					this.setState({
						lastFetchedItemsFromPricing:
							currentPageItemsWithoutPricing
					});

					if (!!dataWithoutPricing?.length) {
						const vendorProducts = getVendorProducts(
							dataWithoutPricing,
							isIcecatEnabled
						);
						const vendorPricingRequest =
							PricingSearchRequest.constructSearchRequest(
								isIcecatEnabled ? [] : vendorProducts,
								isIcecatEnabled ? vendorProducts : [],
								[],
								this.state.excludeDropShipWH,
								productSearchRequest.q
							);

						const pricingResponse = await searchPricing(
							vendorPricingRequest
						);
						const responseDataWithPricing =
							pricingResponse?.data || [];

						const productVsPricingMap =
							responseDataWithPricing.reduce((map, product) => {
								map[product.id] = product.pricing;
								return map;
							}, {});
						const newProductVsPricingIdMap =
							constructProductIdToPricingMapping(
								responseDataWithPricing
							);
						this.setState(prevState => {
							return {
								...prevState,
								dataSource: prevState.dataSource.map(
									product => {
										const latestProductPricing =
											productVsPricingMap[product.id];
										if (latestProductPricing) {
											product.pricing =
												latestProductPricing;
										}
										return product;
									}
								),
								productVsPricing: Object.keys(
									newProductVsPricingIdMap
								).reduce(
									(map, productId) => {
										if (
											!map[productId] ||
											newProductVsPricingIdMap[productId]
										) {
											map[productId] =
												newProductVsPricingIdMap[
													productId
												];
										}
										return map;
									},
									{ ...prevState.productVsPricing }
								)
							};
						});
					}
				} catch (error) {
					console.error(error);
				} finally {
					this.setState({ pricingLoading: false });
				}
			}

			if (updateMetaInfo) {
				this.setState({ metaInfo: productsSearchResponse.meta_info });
			}
		} catch (error) {
			console.error(error);
		} finally {
			this.setState({ loading: false });
			this.loadingRef = false;
		}
	};

	customEmptyProductsTable = () => {
		const isAValidSearch = (this.state.currentKeywords?.length || 0) > 0;
		return isAValidSearch ? (
			<div className="flex flex-col items-center">
				<NoProductFoundIcon className="empty-table-icon" />
				<div className="empty-table-text">
					The item entered is not found. <br />
					Try checking your spelling or use more general terms
				</div>
				<div className="create-product-cta margin-top-8px">
					<ZText colorVariant={7}>OR</ZText>
					<Button
						block
						type="link"
						htmlType="button"
						onClick={this.handleCreateProductClick}
					>
						Create product in your self catalog
					</Button>
				</div>
			</div>
		) : (
			<div className="flex flex-col items-center">
				<SearchSomethingProductsIcon className="empty-table-icon" />
				<div className="empty-table-text">
					Type something to start searching for products.
				</div>
			</div>
		);
	};

	addScrollListener = () => {
		setTimeout(() => {
			const drawer: HTMLElement | null | undefined =
				this.tableContainerRef.current?.querySelector(
					".table-page-container .product-table .ant-table"
				);
			if (drawer) {
				drawer.onscroll = (event: Event) => this.onScroll(event);
			}
		}, 0);
	};

	removeScrollListener = () => {
		const drawer: HTMLElement | null | undefined =
			this.tableContainerRef.current?.querySelector(
				".table-page-container .product-table .ant-table"
			);
		if (drawer) {
			drawer.onscroll = null;
		}
	};

	onScroll = (_$event: Event) => {
		try {
			const drawer: HTMLElement | null | undefined =
				this.tableContainerRef.current?.querySelector(
					".table-page-container .product-table .ant-table"
				);

			if (!drawer) {
				throw new Error("Drawer Query is not available");
			}

			if (!!this.state.loading || !!this.loadingRef) {
				return;
			}

			const scrollThreshold = 60;
			const isAtBottom =
				drawer.offsetHeight + drawer.scrollTop >=
				drawer.scrollHeight - scrollThreshold;

			// Check if pagination cursor exists and the user is at the bottom of the page
			if (!isAtBottom) {
				// Reset pagination trigger when user is not at bottom
				this.setState({ hasTriggeredPagination: false });
				return;
			}

			// Prevent multiple triggers when user is at bottom
			if (this.state.hasTriggeredPagination) {
				return;
			}

			const isFetchingRecursively =
				this.state.dataSource.length >= ETILIZE_PAGE_SIZE;

			if (!this.state.currentCursor || !isFetchingRecursively) {
				return;
			}

			// Mark that we've triggered pagination for this scroll-to-bottom event
			this.setState({ hasTriggeredPagination: true });
			let itemTypeFilter = this.state.selectedProductType;
			if (this.props.isFromProductsPage) {
				itemTypeFilter = this.findProductType(this.props.itemType);
			}

			const shouldFetchRealtimePricing =
				this.state.currentItemSource !== ProductSource.Self;

			const shouldFilterByDistributors = shouldFetchRealtimePricing
				? this.state.filterByConnectedDistributors
				: false;

			const amazonRefineMentsMetaData =
				this.state.metaInfo.amazon_refinements;
			const amazonSearchRequest: AmazonRefinementsFilters = {
				amazon_prime_eligible: this.state.amazonFilterState
					?.amazonPrimeEligible
					? amazonRefineMentsMetaData.prime_eligible[0].value
					: "",
				eligible_for_free_shipping: this.state.amazonFilterState
					?.eligibleForFreeShipping
					? amazonRefineMentsMetaData
							.eligible_for_free_shipping_options[0].value
					: "",
				include_out_of_stock_products:
					this.state.amazonFilterState?.includeOutOfStockProducts?.toString() ??
					"",
				amazon_delivery_date:
					this.state.amazonFilterState?.amazonProductDeliveryDay?.toString() ??
					""
			};

			const source =
				this.state.currentCursor?.current_source ??
				(this.state.currentItemSource === ProductSource.Icecat
					? (this.props.isIcecatIntegrationEnabled &&
							(this.props.isIcecatLocaleFR ||
								(this.props.isIcecatLocaleUS &&
									this.props.isFrenchLanguage))) ||
					  this.props.isIcecatEnabledForAll
						? ProductSource.Icecat
						: ProductSource.Etilize
					: this.state.currentItemSource);

			const searchRequest = ProductSearchRequest.constructSearchRequest(
				this.state.currentKeywords,
				source,
				this.state.currentCursor,
				shouldFetchRealtimePricing,
				shouldFilterByDistributors,
				(this.state.selectedDistributorsV2?.system as Distributor[]) ||
					[],
				this.state.customDistributorsFilters?.length
					? this.state.customDistributorsFilters
					: this.state.selectedDistributorsV2?.custom,
				this.state.excludeOutOfStock,
				this.state.excludeDropShipWH,
				this.state.manufacturerFilters,
				this.state.currentItemSource !== ProductSource.Amazon
					? this.state.categoryFilters
					: this.state.amazonFilterState?.amazonProductCategory,
				this.state.featureFilters,
				itemTypeFilter,
				this.state.selfCatalogFilters,
				false,
				this.state.sortBy,
				this.state.amazonFilterState?.amazonProductSubCategory,
				amazonSearchRequest
			);

			// Call the product list API here
			this.searchProducts(searchRequest, true, false);
		} catch (error) {
			console.error(error);
		}
	};

	onSubmit = ($event: React.MouseEvent<HTMLElement, MouseEvent>) => {
		$event.preventDefault();
		if (
			!(
				this.state.selectedProductList &&
				this.state.selectedProductList.length > 0
			)
		) {
			ZMessage.error("Please select a product");
			return;
		}

		const selectedProductId = this.state.selectedProductList[0].id;

		const currentProductData =
			this.state.dataSource.find(
				product => product.id === selectedProductId
			) || this.state.selectedProductList[0];

		const productToBeAdded = {
			...currentProductData,
			unit_of_measure: currentProductData.unit_of_measure || UOM.EACH,
			selectedPricingId: this.state.productVsPricing[selectedProductId],
			...(selectedProductId.startsWith("custom_distributor:") &&
				this.state.productVsPricing[selectedProductId] && {
					selectedPricing: currentProductData.pricing?.find(
						p =>
							p.id ===
							this.state.productVsPricing[selectedProductId]
					)
				})
		};

		this.props.updateSelectedProduct(productToBeAdded);
		this.submitProductData();
	};

	submitProductData = () => {
		const productList = !this.state.pricingLoading
			? this.state.selectedProductList.map(product => {
					const productWithPricing = this.state.dataSource.find(
						productWithPricing => {
							return product.id === productWithPricing.id;
						}
					);
					if (productWithPricing?.pricing) {
						product.pricing = productWithPricing?.pricing;
					}
					return product;
			  })
			: this.state.selectedProductList;
		this.props.onSubmit(
			productList,
			this.state.productVsPricing,
			this.props.itemType === ProductType.Bundle
		);
	};

	resetCustomFilters = (shouldResetAllFilters: boolean) => {
		if (shouldResetAllFilters) {
			const filterByConnectedDistributors = this.props
				.isDickerDataIntegrated
				? false
				: this.props.distributorsIntegrated;
			this.setState({
				manufacturerFilters: [],
				categoryFilters: [],
				featureFilters: [],
				filterByConnectedDistributors,
				excludeOutOfStock: false,
				excludeDropShipWH: false,
				selectedProductType: [],
				selfCatalogFilters: new SelfCatalogFilters(),
				customDistributorsFilters: [],
				selectedDistributorsV2: {
					system:
						this.props.isCDSearchEnhancementEnabled &&
						filterByConnectedDistributors &&
						this.state.currentItemSource !==
							ProductSource.CustomDistributor
							? this.props.connectedSysDistributors
							: [],
					custom: []
				}
			});
		} else {
			this.setState({
				manufacturerFilters: [],
				categoryFilters: [],
				featureFilters: [],
				selectedProductType: [],
				selfCatalogFilters: new SelfCatalogFilters()
			});
		}
	};

	onApplyFilter = (
		selectedManufactures: string[],
		selectedCategories: string[],
		selectedFeatures: FeatureFilter[],
		selectedProductType: string[],
		selfCatalogFilters: SelfCatalogFilters,
		filterByConnectedDistributors?: boolean,
		excludeOutOfStock?: boolean,
		excludeDropShipWH?: boolean,
		amazonFilterProps?: AmazonFilterProps,
		selectedCustomDistributors?: string[],
		selectedDistributorsV2Data?: { system: string[]; custom: string[] }
	) => {
		if (
			(this.state.currentItemSource === ProductSource.Etilize ||
				this.state.currentItemSource === ProductSource.Icecat) &&
			!this.state.currentKeywords?.length
		) {
			return;
		}

		// Reset scroll position to top when filters are applied
		setTimeout(() => {
			const drawer: HTMLElement | null | undefined =
				this.tableContainerRef.current?.querySelector(
					".table-page-container .product-table .ant-table"
				);
			if (drawer) {
				drawer.scrollTop = 0;
			}
		}, 100);
		let itemTypeFilter = selectedProductType;
		if (this.props.isFromProductsPage) {
			itemTypeFilter = this.findProductType(this.props.itemType);
		}
		const shouldFetchRealtimePricing =
			this.state.currentItemSource !== ProductSource.Self;

		const shouldFilterByDistributors = shouldFetchRealtimePricing
			? filterByConnectedDistributors
			: false;

		const amazonRefineMentsMetaData =
			this.state.metaInfo.amazon_refinements;
		const amazonSearchRequest: AmazonRefinementsFilters = {
			amazon_prime_eligible: amazonFilterProps?.amazonPrimeEligible
				? amazonRefineMentsMetaData?.prime_eligible[0]?.value
				: "",
			eligible_for_free_shipping:
				amazonFilterProps?.eligibleForFreeShipping
					? amazonRefineMentsMetaData
							?.eligible_for_free_shipping_options[0]?.value
					: "",
			include_out_of_stock_products:
				amazonFilterProps?.includeOutOfStockProducts?.toString() ?? "",
			amazon_delivery_date:
				amazonFilterProps?.amazonProductDeliveryDay?.toString() ?? ""
		};
		const source =
			this.state.currentItemSource === ProductSource.Icecat
				? (this.props.isIcecatIntegrationEnabled &&
						(this.props.isIcecatLocaleFR ||
							(this.props.isIcecatLocaleUS &&
								this.props.isFrenchLanguage))) ||
				  this.props.isIcecatEnabledForAll
					? ProductSource.Icecat
					: ProductSource.Etilize
				: this.state.currentItemSource;
		// Get current search input value to ensure we use the latest keywords
		const currentSearchValue =
			this.searchInputRef.current?.input?.value ||
			this.state.currentKeywords;

		const searchRequest = ProductSearchRequest.constructSearchRequest(
			currentSearchValue,
			source,
			null,
			shouldFetchRealtimePricing,
			shouldFilterByDistributors,
			(selectedDistributorsV2Data?.system as Distributor[]) || [],
			selectedCustomDistributors?.length
				? selectedCustomDistributors
				: selectedDistributorsV2Data?.custom,
			excludeOutOfStock,
			excludeDropShipWH,
			selectedManufactures,
			this.state.currentItemSource !== ProductSource.Amazon
				? selectedCategories
				: amazonFilterProps?.amazonProductCategory,
			selectedFeatures,
			itemTypeFilter,
			selfCatalogFilters,
			false,
			this.state.sortBy,
			amazonFilterProps?.amazonProductSubCategory,
			amazonSearchRequest
		);

		this.setState({
			manufacturerFilters: selectedManufactures,
			categoryFilters: selectedCategories,
			featureFilters: selectedFeatures,
			filterByConnectedDistributors: !!filterByConnectedDistributors,
			excludeOutOfStock: !!excludeOutOfStock,
			excludeDropShipWH: !!excludeDropShipWH,
			selectedProductType: selectedProductType,
			selfCatalogFilters: selfCatalogFilters,
			currentCursor: null,
			amazonFilterState: {
				includeOutOfStockProducts:
					amazonFilterProps?.includeOutOfStockProducts,
				eligibleForFreeShipping:
					amazonFilterProps?.eligibleForFreeShipping,
				amazonPrimeEligible: amazonFilterProps?.amazonPrimeEligible,
				amazonProductCategory: amazonFilterProps?.amazonProductCategory,
				amazonProductSubCategory:
					amazonFilterProps?.amazonProductSubCategory,
				amazonProductDeliveryDay:
					amazonFilterProps?.amazonProductDeliveryDay
			},
			customDistributorsFilters: selectedCustomDistributors ?? [],
			selectedDistributorsV2: selectedDistributorsV2Data ?? {
				system: [],
				custom: []
			}
		});
		this.searchProducts(searchRequest, false, true);
	};

	handleProductRowEvent = (record: Product) => ({
		onClick: () => {
			if (record.product_source === ProductSource.ZomentumMarketplace) {
				const currentProductVendorStatus =
					this.props.vendorProgramDetails.find(v => {
						return v.id === record.vendor_company_id;
					})?.status ?? VendorSubscriptionStatus.NOTAPPLIED;
				if (
					currentProductVendorStatus !==
					VendorSubscriptionStatus.ACCEPTED
				)
					// should not select product since all unjoined vendor skus are disabled
					return;
			}
			this.props.itemType === ProductType.Bundle
				? this.setState({ selectedProductList: [record] })
				: this.setState(prevState => ({
						selectedProductList: prevState.selectedProductList.some(
							product => product.id === record.id
						)
							? prevState.selectedProductList.filter(
									product => product.id !== record.id
							  )
							: [...prevState.selectedProductList, record]
				  }));
		},
		onDoubleClick: () =>
			this.props.itemType === ProductType.Bundle
				? this.submitProductData
				: null
	});

	handleCreateProductAdded = (addedProduct: Product) => {
		const updatedDataSource =
			this.state.currentItemSource === ProductSource.Self
				? [addedProduct, ...this.state.dataSource]
				: this.state.dataSource;

		const updatedProductVsPricing = {
			...this.state.productVsPricing,
			[addedProduct.id]: getPreferredPricingForProduct(addedProduct)
		};

		this.setState({
			createProductButtonVisible: false,
			dataSource: updatedDataSource,
			productVsPricing: { ...updatedProductVsPricing }
		});
	};

	renderTableHeader = (): React.ReactNode => {
		const isSearchDisabled =
			this.state.currentItemSource === ProductSource.Amazon &&
			!this.props.isAmazonDistributorIntegrated;
		const amazonFilterValues = this.state.amazonFilterState;
		const amazonFilterProps = {
			includeOutOfStockProducts:
				amazonFilterValues?.includeOutOfStockProducts,
			eligibleForFreeShipping:
				amazonFilterValues?.eligibleForFreeShipping,
			amazonPrimeEligible: amazonFilterValues?.amazonPrimeEligible,
			amazonProductCategory: amazonFilterValues?.amazonProductCategory,
			amazonProductSubCategory:
				amazonFilterValues?.amazonProductSubCategory,
			amazonProductDeliveryDay:
				amazonFilterValues?.amazonProductDeliveryDay
		};

		return (
			<Row className="document-product-drawer-product-header w-full">
				<Col
					span={4}
					onClick={this.stopPropagation}
					className="document-product-drawer-product-source w-full"
				>
					<Select<ProductSource>
						getPopupContainer={trigger => trigger.parentNode}
						allowClear={false}
						loading={this.props.isLoading || this.state.loading}
						defaultValue={ProductSource.Self}
						value={this.state.currentItemSource}
						placeholder="Please choose the product source"
						onChange={this.onProductSourceChange}
						dropdownClassName="w-min"
						dropdownRender={menu => (
							<div>
								{menu}
								<ZFeatureAccess
									requiredRole={UserRole.SecondaryRole}
									requiredPlan={PricingPlanNames.IGNITE}
									permissions={
										this.props.createProductPermission
									}
								>
									<div
										className="create-product-dropdown-cta"
										onClick={this.handleCreateProductClick}
									>
										Create Product
									</div>
								</ZFeatureAccess>
							</div>
						)}
						className="w-full"
					>
						{!this.props.isUnifiedSearchEnabled && (
							<Select.Option value={ProductSource.Self}>
								Self
							</Select.Option>
						)}
						{this.props.isIcecatIntegrationEnabled ? (
							<Select.Option value={ProductSource.Icecat}>
								{this.props.userCompany.settings
									.is_icecat_integration_enabled
									? "Global Catalogue"
									: "Global Catalogue (Formerly Etilize)"}
							</Select.Option>
						) : (
							<Select.Option value={ProductSource.Etilize}>
								Etilize
							</Select.Option>
						)}
						{this.props.marketplaceFlag &&
							this.props.showPartnerAlignFeaturesFlag && (
								<Select.Option
									value={ProductSource.ZomentumMarketplace}
								>
									Align
								</Select.Option>
							)}
						{this.props.itemType !== ProductType.Bundle &&
							(this.props.hasPermissionForAmazonDistributor ||
								this.props.isInternalUser) && (
								<Select.Option value={ProductSource.Amazon}>
									Amazon
								</Select.Option>
							)}
						{this.props.enableCustomDistributorSeparateTabFlag &&
							!this.props.isUnifiedSearchEnabled && (
								<Select.Option
									value={ProductSource.CustomDistributor}
								>
									Custom Distributor
								</Select.Option>
							)}
					</Select>
				</Col>
				<Col
					span={20}
					className="document-product-drawer-product-button"
				>
					<Input.Search
						ref={this.searchInputRef}
						placeholder="Enter product name"
						enterButton={
							<Button
								type="primary"
								htmlType="button"
								icon={<SearchOutlined />}
								loading={
									this.props.isLoading || this.state.loading
								}
								disabled={isSearchDisabled}
							>
								Search
							</Button>
						}
						onSearch={currentKeywords =>
							this.onProductSearchKeywordChange(currentKeywords)
						}
						disabled={isSearchDisabled}
					/>
				</Col>
				{this.state.currentItemSource !== ProductSource.Amazon ||
				(this.props.isAmazonDistributorIntegrated &&
					this.state.currentItemSource === ProductSource.Amazon) ? (
					<Col span={24} className="mt-3">
						<ItemFiltersMenu
							isFromProductsPage={this.props.isFromProductsPage}
							currentItemSource={this.state.currentItemSource}
							keyWord={this.state.currentKeywords}
							metaInfo={this.state.metaInfo}
							manufacturerFilters={this.state.manufacturerFilters}
							categoryFilters={this.state.categoryFilters}
							featureFilters={this.state.featureFilters}
							filterByConnectedDistributors={
								this.state.filterByConnectedDistributors
							}
							excludeOutOfStock={this.state.excludeOutOfStock}
							excludeDropShipWH={this.state.excludeDropShipWH}
							onApply={this.onApplyFilter}
							selectedProductType={this.state.selectedProductType}
							selfCatalogFilters={this.state.selfCatalogFilters}
							disableLimitDistributorOption={
								!this.state.dataSource.length &&
								!this.state.filterByConnectedDistributors &&
								this.props.isDickerDataIntegrated
							}
							handleSortingOptionChange={
								this.handleSortingOptionChange
							}
							itemType={this.props.itemType}
							amazonFilterProps={amazonFilterProps}
							customDistributorsFilters={
								this.state.customDistributorsFilters
							}
							selectedDistributorsV2={
								this.state.selectedDistributorsV2
							}
							isCDSearchEnhancementEnabled={
								this.props.isCDSearchEnhancementEnabled
							}
						/>
					</Col>
				) : null}
			</Row>
		);
	};

	etilizeProductsLoader = () => {
		return (
			<div className="flex justify-center items-center mb-7">
				<ZImage
					src={ZomentumLogo}
					alt="Fetching products..."
					className="h-7 w-7 mr-2"
					preview={false}
				/>
				Loading more products
				<span className="recursive-loader">
					<span className="dot dot-1">.</span>
					<span className="dot dot-2">.</span>
					<span className="dot dot-3">.</span>
				</span>
			</div>
		);
	};

	handleSortingOptionChange = (value: SortOptions | undefined) => {
		if (
			(this.state.currentItemSource as ProductSource) ===
			ProductSource.Icecat
		) {
			this.setState({
				sortBy: value,
				currentCursor: null,
				dataSource: this.sortDataSource(this.state.dataSource, value)
			});
			return;
		}
		let itemTypeFilter = this.state.selectedProductType;
		if (this.props.isFromProductsPage) {
			itemTypeFilter = this.findProductType(this.props.itemType);
		}
		this.setState({ sortBy: value, currentCursor: null, dataSource: [] });
		const shouldFetchRealtimePricing =
			this.state.currentItemSource !== ProductSource.Self;
		const shouldFilterByDistributors = false;

		const searchRequest = ProductSearchRequest.constructSearchRequest(
			this.state.currentKeywords,
			this.state.currentItemSource === ProductSource.Icecat
				? (this.props.isIcecatIntegrationEnabled &&
						(this.props.isIcecatLocaleFR ||
							(this.props.isIcecatLocaleUS &&
								this.props.isFrenchLanguage))) ||
				  this.props.isIcecatEnabledForAll
					? ProductSource.Icecat
					: ProductSource.Etilize
				: this.state.currentItemSource,
			null,
			shouldFetchRealtimePricing,
			shouldFilterByDistributors,
			(this.state.selectedDistributorsV2?.system as Distributor[]) || [],
			this.state.customDistributorsFilters?.length
				? this.state.customDistributorsFilters
				: this.state.selectedDistributorsV2?.custom,
			this.state.excludeOutOfStock,
			this.state.excludeDropShipWH,
			this.state.manufacturerFilters,
			this.state.categoryFilters,
			this.state.featureFilters,
			itemTypeFilter,
			this.state.selfCatalogFilters,
			false,
			value
		);
		this.searchProducts(searchRequest, false, true);
	};

	render() {
		const { currentItemSource, selectedProductList } = this.state;

		const productRowSelection: TableRowSelection<Product> = {
			onChange: (
				selectedProductIdList: ReactText[],
				selectedProductList: Product[]
			) => {
				const updatedSelectedProducts = selectedProductIdList
					.map(productId => {
						const currentProductData = this.state.dataSource.find(
							product => product.id === productId
						);
						if (currentProductData) {
							return currentProductData;
						}

						const previousProductData =
							this.state.selectedProductList.find(
								product => product.id === productId
							);
						if (previousProductData) {
							return previousProductData;
						}

						return selectedProductList.find(
							product => product.id === productId
						);
					})
					.filter(product => product) as Product[];

				this.setState({
					selectedProductList: updatedSelectedProducts
				});
			},
			type:
				this.props.itemType !== ProductType.Bundle
					? "checkbox"
					: "radio",
			selectedRowKeys: this.state.selectedProductList.map(
				product => product?.id
			),
			columnWidth: 20,
			preserveSelectedRowKeys: true,
			getCheckboxProps: (record: Product) => {
				const isMarketplaceSku =
					record.product_source === ProductSource.ZomentumMarketplace;
				const currentProductVendorStatus =
					this.props.vendorProgramDetails.find(v => {
						return v.id === record.vendor_company_id;
					})?.status ?? VendorSubscriptionStatus.NOTAPPLIED;
				const isSkuDisabled =
					isMarketplaceSku &&
					currentProductVendorStatus !==
						VendorSubscriptionStatus.ACCEPTED;
				return {
					disabled: isSkuDisabled
				};
			}
		};

		const showRecursiveLoader =
			(this.props.isLoading ||
				this.state.loading ||
				!this.state.dataSource.length ||
				this.state?.dataSource?.length < ETILIZE_PAGE_SIZE) &&
			!!this.state.currentCursor;

		return this.state.currentItemSource === ProductSource.Amazon &&
			!this.props.isAmazonDistributorIntegrated ? (
			<>
				<Row className="amazon-integrate-form-header">
					{this.renderTableHeader()}
				</Row>
				<IntegrateAmazonForm />
				<div className="ant-drawer-footer">
					<ZButton
						type="default"
						htmlType="button"
						onClick={this.onClose}
						disabled={this.props.isLoading || this.state.loading}
						className="mr-4"
					>
						Cancel
					</ZButton>
					<ZButton type="primary" htmlType="button" disabled={true}>
						Add Products
					</ZButton>
				</div>
			</>
		) : (
			<div ref={this.tableContainerRef}>
				<Row className="drawer-form-container no-padding">
					<Col
						span={24}
						className="table-page-container product-table-container"
					>
						<ConfigProvider
							renderEmpty={
								!this.state.loading
									? this.customEmptyProductsTable
									: undefined
							}
						>
							<ZTable
								title={this.renderTableHeader}
								showHeader={false}
								loading={
									(this.props.isLoading ||
										this.state.loading ||
										!this.state.dataSource) &&
									!showRecursiveLoader
								}
								scroll={{ scrollToFirstRowOnChange: false }}
								size="small"
								dataSource={this.state.dataSource}
								columns={this.productColumns}
								rowKey="id"
								pagination={false}
								rowSelection={productRowSelection}
								onRow={this.handleProductRowEvent}
								className="product-table"
								footer={
									showRecursiveLoader
										? this.etilizeProductsLoader
										: undefined
								}
							/>
						</ConfigProvider>
					</Col>
				</Row>
				<div className="ant-drawer-footer">
					<Button
						type="default"
						htmlType="button"
						onClick={this.onClose}
						disabled={this.props.isLoading || this.state.loading}
						className="mr-4"
					>
						Cancel
					</Button>
					<Button
						type="primary"
						htmlType="button"
						loading={
							this.props.isLoading ||
							this.state.loading ||
							!this.state.dataSource
						}
						disabled={!selectedProductList.length}
						onClick={this.onSubmit}
					>
						{this.props.itemType === ProductType.Bundle
							? "Next"
							: "Add Products"}
					</Button>
				</div>
				<AddProductDrawerV2
					shouldRedirectToProduct={false}
					visible={this.state.createProductButtonVisible}
					onClose={this.handleOnClose}
					onAdd={this.handleCreateProductAdded}
					drawerState={EProductDrawerState.ADD}
				/>
				{this.props.itemType === ProductType.Bundle ? (
					this.props.configureDrawer
				) : (
					<ZUpdateMandatoryFieldsForQuoteBlockDrawer
						visible={
							(this.props.unfilledSelectedQuoteProductIds ?? [])
								.length > 0
						}
						onClose={() => this.props.resetQuoteProducts?.()}
						renderProductColumn={this.renderProductColumn(true)}
						products={selectedProductList}
						unfilledProducts={selectedProductList.filter(product =>
							(
								this.props.unfilledSelectedQuoteProductIds ?? []
							).some(id => id === product.id)
						)}
						removeProducts={products =>
							this.removeItemsFromUpdateMandatoryFieldsDrawer(
								products
							)
						}
					>
						{this.props.configureDrawer}
					</ZUpdateMandatoryFieldsForQuoteBlockDrawer>
				)}
			</div>
		);
	}
}

export default connect(
	() => mapStateToProps,
	mapDispatchToProps
)((props: Props) => {
	const EtilizePricingOn = useFeatureFlag("etilize_pricing");
	const MarketplaceFlag = useFeatureFlag("marketplace_sku");
	const showPartnerAlignFeaturesFlag = useFeatureFlag(
		"show_partner_align_features"
	);
	const isIcecatIntegrationEnabled = useFeatureFlag("icecat_integration");
	const isIcecatEnabledForAll = useFeatureFlag("icecat_enabled_for_all");
	const alwaysAllowAmazonDistributor = useFeatureFlag(
		"always_allow_amazon_distributor"
	);
	const newPricingConstraints = useFeatureFlag("new_pricing_constraints");
	const hasGrowthPlanAccess = useFeatureAccess(
		PricingPlanNames.GROWTH,
		UserRole.UserRole
	);
	const hasExpandPlanAccess = useFeatureAccess(
		PricingPlanNames.EXPAND,
		UserRole.UserRole
	);
	const customDistributerInSearchDocumentProductCatalogueFlag =
		useFeatureFlag(
			"custom_distributer_in_search_document_product_catalogue"
		);
	const enableCustomDistributorSeparateTabFlag = useFeatureFlag(
		"enable_custom_distributor_separate_tab"
	);
	const isCDSearchEnhancementEnabled = useFeatureFlag(
		"cd_search_enhancement"
	);
	const createProductPermission = usePermissions(
		Modules.ITEM,
		ModulePermission.CREATE_EDIT_DELETE_OWNED
	);
	const hasAmazonAddOn = useSelector(
		(state: GlobalState) =>
			!!state.user.subscriptionDetails.addons.find(addOn =>
				addOn.id?.includes(PricingAddOnEnum.AMAZON_BUSINESS)
			)
	);
	const hasExpandPlanWithAmazonAddOn = hasExpandPlanAccess && hasAmazonAddOn;
	const hasPermissionForAmazonDistributor = newPricingConstraints
		? alwaysAllowAmazonDistributor ||
		  hasExpandPlanWithAmazonAddOn ||
		  hasGrowthPlanAccess ||
		  props.isInternalUser
		: alwaysAllowAmazonDistributor ||
		  hasGrowthPlanAccess ||
		  props.isInternalUser;
	return (
		<SearchDocumentProductCatalog
			{...props}
			isEtilizePricingOn={EtilizePricingOn}
			marketplaceFlag={MarketplaceFlag}
			showPartnerAlignFeaturesFlag={showPartnerAlignFeaturesFlag}
			createProductPermission={createProductPermission}
			isIcecatIntegrationEnabled={isIcecatIntegrationEnabled}
			isIcecatEnabledForAll={isIcecatEnabledForAll}
			customDistributerInSearchDocumentProductCatalogueFlag={
				customDistributerInSearchDocumentProductCatalogueFlag
			}
			enableCustomDistributorSeparateTabFlag={
				enableCustomDistributorSeparateTabFlag
			}
			hasPermissionForAmazonDistributor={
				hasPermissionForAmazonDistributor
			}
			isCDSearchEnhancementEnabled={isCDSearchEnhancementEnabled}
		/>
	);
});
